"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PORTRAIT_SIZE_PARAMS = exports.PORTRAIT_SIZES = exports.PORTRAIT_SHAPES = void 0;
const PORTRAIT_SHAPES = ["circle", "square"];
exports.PORTRAIT_SHAPES = PORTRAIT_SHAPES;
const PORTRAIT_SIZES = ["XS", "S", "M", "ML", "L", "XL", "XXL"];
exports.PORTRAIT_SIZES = PORTRAIT_SIZES;
const PORTRAIT_SIZE_PARAMS = {
  XS: {
    dimensions: 24,
    iconDimensions: 16
  },
  S: {
    dimensions: 32,
    iconDimensions: 16
  },
  M: {
    dimensions: 40,
    iconDimensions: 24
  },
  ML: {
    dimensions: 56,
    iconDimensions: 32
  },
  L: {
    dimensions: 72,
    iconDimensions: 32
  },
  XL: {
    dimensions: 104,
    iconDimensions: 48
  },
  XXL: {
    dimensions: 128,
    iconDimensions: 64
  }
};
exports.PORTRAIT_SIZE_PARAMS = PORTRAIT_SIZE_PARAMS;